import { apiClient } from './api-client';
import { API_URL } from './constants';

if (!API_URL) {
    throw new Error(`make sure the API_URL environment variable is defined`)
}

export const api = apiClient;